import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';

export const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      title: 'Reserve Your RED-E-BIN Online',
      description:
        "Choose your dumpster bin size & type, tell us where and when you need it, confirm availability, reserve, and pay online. It's that simple! Check out our different sizes and browse our inventory",
      link: '/dumpster-sizes',
    },
    {
      number: '2',
      title: 'Get It Delivered',
      description:
        "Our smaller 5YD/8x4x4 dumpster bin fits in a compact sedan parking space and holds about 1–2 pickup truck loads; our larger 10YD/10x5x5 dumpster bin fits where you'd park a larger sedan and holds about 3–4 pickup truck loads.",
    },
    {
      number: '3',
      title: 'Fill It Up',
      description:
        "RED-E-BINS let you toss everything from everyday clutter to construction debris—see our DOs and DON'Ts",
      link: '/prohibited-items',
    },
    {
      number: '4',
      title: 'Say Good-Bye',
      description:
        "We'll come take your full RED-E-BIN Dumpster out of your life—and we recycle, donate, or responsibly dispose of every item inside.",
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-4 italic text-center">
            How RED-E-BINS Works
          </h2>
          <p className="text-center text-[#333333] mb-12 italic">
            You're just a few clicks from getting a RED-E-BIN Dumpster delivered directly to you.
          </p>

          <div className="grid md:grid-cols-2 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-xl font-semibold text-[#E31837] mb-3">
                  {step.number}. {step.title}
                </h3>
                <p className="text-[#333333] mb-4">
                  {step.description}
                  {step.link && (
                    <>
                      {' '}
                      <Link
                        href={step.link}
                        className="text-[#E31837] hover:underline font-semibold"
                      >
                        here
                      </Link>
                      .
                    </>
                  )}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <div className="inline-block bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-bold text-[#333333] mb-2">
                Need Assistance?
              </h3>
              <a
                href="tel:9529312577"
                className="text-3xl font-bold text-[#E31837] hover:underline block mb-4"
              >
                952-931-2577
              </a>
              <Link
                href="/#dumpster-sizes"
                className="inline-block bg-[#E31837] text-white px-8 py-3 rounded-md font-semibold hover:bg-[#C1152E] transition-colors"
              >
                Click Here to Choose Your Dumpster Size
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

